import type { StoryObj } from '@storybook/html'

export default {
  title: 'Components/Navigation/cobalt-breadcrumb'
}

const TemplateDefault = () => {
  return `
<cobalt-breadcrumb>
  <li><cobalt-link label="crumb1" href="#" title="Explicit description of the destination of this link"></cobalt-link></li>
  <li><cobalt-link label="crumb2" href="#" title="Explicit description of the destination of this link"></cobalt-link></li>
  <li><cobalt-link label="crumb3" href="#" title="Explicit description of the destination of this link"></cobalt-link></li>
</cobalt-breadcrumb>`
}

export const Default: StoryObj = TemplateDefault.bind({})
